<div class="menu" (click)="close()">
  <div class="container column">
    <h2 class="center mat-title-large">{{'game.round' | translate}} {{roundCount()}}</h2>
    <h1 class="center mat-display-large">{{'game.guess.types.' + guessType() + '.name' | translate}}</h1>
    <div class="center mat-body">{{'game.guess.types.' + guessType() + '.title' | translate: guessTitleParams() }}</div>
    @if (guessModifier() !== guessModifiers.NONE) {
    <div class="center modifier animate__animated animate__pulse">{{'game.guess.modifiers.' + guessModifier() | translate}}</div>
    }
  </div>
</div>
